/**
 * 报价配置相关请求
 */
import request from "@/utils/request";

export interface OfferPremiumRequestParams {
    id?: number;  //唯一标识
    item?: string | null; //指标名称
    subItem1?: string | null; //子指标名称
    area?: string | null; //行政区域
    areas?: string[] | null;
    factor?: number | string | null; //系数
    factor1?: number | string | null;
    factor2?: number | string | null;
    factor3?: number | string | null;
    factor4?: number | string | null;
    factor5?: number | string | null;
    factor6?: number | string | null;
    factor7?: number | string | null;
    type?: string; //指标类型
    [property: string]: any;
}

export const offerPremiumListRequestPath = '/api/v2/car/premium/config/list';

// 查询配置列表数据
export const offerPremiumListRequest = () => {
    return request.get(offerPremiumListRequestPath)
}

// 添加配置列表数据
export const offerPremiumAdd = (OfferPremiumRequestParams: OfferPremiumRequestParams) => {
    return request.post('/api/v2/car/premium/config/upsert', OfferPremiumRequestParams)
}

// 删除配置记录
export const offerPremiumDelete = (id: number) => {
    return request.delete(`/api/v2/car/premium/config/${id}`)
}

// 获取区域
export const areaInsuranceListRequest = () => {
    return request.get('/api/v2/car/area/insurance/list')
}
